import {
    css, Theme,
} from '@emotion/react'

import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        form: custom.stepElementPadding,
        summaryText: css` white-space: pre-line `,
    }
}

export const textFieldHelperTextStyle = (theme: Theme) => {
    return { root: css`
        color: ${theme.palette.primary[200]};
        font: normal normal 400 ${theme.typography.h4.fontSize}px/${theme.typography.h4.lineHeight} Roboto;
    ` }
}

export const textFieldStyle = (theme: Theme) => {
    return css`
        & .MuiInputBase-root {
          color: ${theme.palette.secondary[600]};
          font: normal normal 400 ${theme.typography.h3.fontSize}px/${theme.typography.h3.lineHeight} Roboto;
        }
    `
}

export default styles
